export const STEPS_COUNT = 3;
